import React from 'react'
import { Text } from '../../../'
import { DeacriptionDiv, TextDiv } from './description.styled.component'

export const DescriptionComponent = ({ collection }) => {
  if(collection !== null){
    return (
      <DeacriptionDiv>
        <TextDiv>
          <Text className="pr-md-5" fontSize="16px" fontFamily="" textId={collection.description} />
        </TextDiv>
      </DeacriptionDiv>
    )
  }
  return null
};
